<template>
  <!-- header -->
  <div class="zze-header">
    <div class="logo" :class="is_collapse ? 'logo_sm' : ''">
      <a href="/"> <img src="@/assets/images/logo.png" alt="">
        <div class="info" v-if="!is_collapse">
          <span>ThisAdmin平台后台</span>
        </div>
      </a>
    </div>
    <!-- 折叠按钮 -->
    <div class="ele-header-tool">
      <div class="ele-header-tool-item" @click="isCollapseHold">
        <i class="iconfont" :class="is_collapse ?'icon-zhankai':'icon-shouqi'"></i>
      </div>
    </div>
    <div class="crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name:'admin'}">主页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in crumb" :key="index">{{ item }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <ul class="header-right">
      <li class="item">
        <el-link @click="dropNav">
          您好，{{ account.username }}（{{ account.realname }}） <span :class="is_show?'more show':'more'"></span>
        </el-link>
        <dl :class="is_show?'subnav show':'subnav'" v-show="is_show">
          <dd>
            <el-link @click="showFrom">基本资料</el-link>
          </dd>
          <dd>
            <el-link @click="showPwdFrom">修改密码</el-link>
          </dd>
          <dd>
            <el-link @click="clearCache">清除缓存</el-link>
          </dd>
        </dl>
      </li>
      <li class="item">
        <el-link @click="logout">退出</el-link>
      </li>
    </ul>
  </div>
  <!-- form 表单 基本资料-->
  <el-dialog v-model="formVisible" title="基本资料编辑">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="姓名" prop="realname">
        <el-input v-model="form.realname" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-row class="btns-submit">
        <el-button type="primary" @click="submit">立即提交</el-button>
        <el-button @click="closeFrom">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>
  <el-dialog v-model="pwdFormVisible" title="修改密码">
    <el-form ref="pwdform" :model="pwdform" :rules="rules" label-width="120px">
      <el-form-item label="旧密码" prop="oldpassword">
        <el-input type="password" v-model="pwdform.oldpassword" placeholder="请输入旧密码！"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input type="password" v-model="pwdform.password" placeholder="请输入密码，密码包含字母和数字 6~12位"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input type="password" v-model="pwdform.repassword" placeholder="请再输入一遍密码以便确认"></el-input>
      </el-form-item>
      <el-row class="btns-submit">
        <el-button type="primary" @click="submitPwd">立即提交</el-button>
        <el-button @click="closePwdFrom">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import account from "@/api/account";
import {setAccount,getAccount,removeTokenAndAccount} from "../utils/auth";

export default {
  name: "topbar",
  data() {
    var validPwd = (rule, value, callback) => {
      //密码只能由大小写英文字母或数字开头，且由大小写英文字母_.组成
      const reg = /^[A-Za-z0-9][A-Za-z0-9_.]{5,17}$/
      if (!value.match(reg)) {
        callback(new Error('账号由字母或数字开头，且只能为字母,数字,下划线及（.）长度在 6 到 18 个字符'))
      } else {
        callback()
      }
    }
    var validRePwd = (rule, value, callback) => {
      if (value !== this.pwdform.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      is_show: false,
      formVisible: false,
      pwdFormVisible: false,
      is_collapse: false,
      crumb: [],//面包屑
      account: {},
      form: {
        realname: '',
        mobile: '',
        email: '',
        avatar: ''
      },
      pwdform: {
        oldpassword: '',
        password: '',
        repassword: ''
      },
      rules: {
        oldpassword: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}, {validator: validPwd, trigger: 'blur'}],
        repassword: [{required: true, message: '请输入确认密码', trigger: 'blur'}, {validator: validRePwd, trigger: 'blur'}],
        realname: [{required: true, message: '请输入真实姓名', trigger: 'blur'}, {min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur'}]
      }
    }
  },
  created() {
    this.account = getAccount();
  },
  mounted() {
    //this.$emit("isCollapseController",this.is_collapse);
  },
  watch: {
    $route: {
      handler() {
        this.crumb = this.getCrumb();
      },
      immediate: true
    }
  },
  methods: {
    //面包屑
    getCrumb() {
      let temp = [], temps = [];
      this.$route.matched.filter((item) => {
        if (item.meta.title) {
          const title = item.meta.title;
          temp.push(title);
        }
      });
      temp.filter((item) => {
        if (!temps.includes(item)) {
          temps.push(item);
        }
      })
      return temps;
    },
    //侧边导航栏 折叠
    isCollapseHold() {
      this.is_collapse = !this.is_collapse;
      this.$emit("isCollapseController", this.is_collapse);
    },
    //二级菜单显示与隐藏
    dropNav() {
      this.is_show = !this.is_show;
    },
    //退出
    async logout() {
      const that = this;
      //管理后台登录
      account.logout({
        ident: 'logout'
      }).then(function (res) {
        if (res) {
          removeTokenAndAccount();
          that.$message.success(res.msg);
          that.$router.push('/login');
        }
      })
    },
    //弹出基本资料
    showFrom() {
      this.form = getAccount();
      this.formVisible = true;
      this.dropNav();
    },
    //关闭-弹出基本资料
    closeFrom() {
      this.formVisible = false;
    },
    //修改基本资料
    async submit() {
      const that = this;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          account.editLoginAdmin({
            form: that.form
          }).then(function (res) {
            if (res) {
              setAccount(res.data);
              that.account = getAccount();
              that.$message.success(res.msg);
            }
            that.formVisible = false;
          });
        } else {
          return false
        }
      })
    },
    //弹出修改密码
    showPwdFrom() {
      this.pwdFormVisible = true;
      this.dropNav();
    },
    //关闭-弹出修改密码
    closePwdFrom() {
      this.pwdFormVisible = false;
    },
    //修改密码
    async submitPwd() {
      const that = this;
      this.$refs['pwdform'].validate((valid) => {
        if (valid) {
          account.editLoginPwd({
            form: that.pwdform
          }).then(function (res) {
            if (res) {
              that.$message.success(res.msg)
            }
            that.pwdFormVisible = false;
          });
        } else {
          return false
        }
      })
    },
    //清除缓存
    clearCache() {
      const that = this;
      account.clearCache({
        form: 'no'
      }).then(function (res) {
        if (res) {
          that.$message.success(res.msg)
        }
        that.dropNav();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.logo_sm {
  width: 64px !important;
}
</style>
